import { render, staticRenderFns } from "./Inter.vue?vue&type=template&id=a0dbcff6&scoped=true"
import script from "./Inter.vue?vue&type=script&lang=js"
export * from "./Inter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dbcff6",
  null
  
)

export default component.exports